export enum DocumentExportJobMode {
  INLINE = 'INLINE',
  ASYNC = 'ASYNC',
}
